export default "__VITE_ASSET__DJRCO4ze__"